import RequestService from '@/utils/service'

export default {
  state: {
    list: [],
    visible: false,
    onsale: {},
    onsaleVisible: false,
  },

  mutations: {
    setProducts (state, list) {
      state.list = list
    },

    showProducts (state) {
      state.visible = true
    },

    setProductPaid (state, id) {
      let row = state.list.find(item => item.id === id)
      row.whetherBuy = true
    },
    
    setProductOnsale (state, product) {
      let row = state.list.find(item => item.id === product.id)

      if (row) {
        row.onsale = true
        state.onsale = row
        state.onsaleVisible = true
        setTimeout(() => state.onsaleVisible = false, 20000)
      }
    },

    hideProducts (state) {
      state.visible = false
    }
  },

  actions: {
    getProducts ({ commit }, roomId) {
      RequestService({ url: '/liveGoods/list', data: { liveRoomId: roomId, limit: 100 }}).then(res => {
        const list = res.result.rows.map(item => {
          const boldNameArray = item.name.match(/\【(.+?)\】/g)
          if (boldNameArray && boldNameArray.length) {
            item.boldName = boldNameArray[0]
            item.name = item.name.replace(item.boldName, '')
          }

          const boldDetailArray = item.detail.match(/\【(.+?)\】/g)
          if (boldDetailArray && boldDetailArray.length) {
            boldDetailArray.map(boldItem => {
              item.detail = item.detail.replace(boldItem, '<span style="font-size: .28rem; font-weight: 700; color: #F51614">' + boldItem + '</span>')
            })
          }
          
          item.detail = item.detail.replace(/\n|\r\n/g, '<br>')

          return item
        })

        commit('setProducts', list)
      })
    },
  }
}